import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/display-name
interface PageType {
  title:string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children:any
}

// eslint-disable-next-line react/display-name
const Page = forwardRef<HTMLDivElement, PageType>(({
  children,
  title = '',
  ...rest
}, ref) => {
  return (
    <div
      ref={ref}
      {...rest}
      // style={{height:'100%'}}
    >
      <Helmet>
        <title>{title} | Combine Harvester</title>
      </Helmet>
      {children}
    </div>
  );
});

// Page.propTypes = {
//   children: PropTypes.node.isRequired,
//   title: PropTypes.string
// };

export default Page;
